import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { StringHelper } from "@mpt-fo/common/core/helpers/strings.helper";
import { AuthenticationService } from "@mpt-fo/common/core/services/authentication.service";
import { AuthorizedUser } from "@mpt-fo/common/core/services/authorized-user.service";
import { AuthenticationEvents, DataLayerService } from "@mpt-fo/common/core/services/data-layer-service.service";
import { DeviceHelperService } from "@mpt-fo/common/core/services/device-helper.service";
import { LivelinessErrorCode, LivelinessService } from "@mpt-fo/common/core/services/liveliness.service";
import { LoginHelperService } from "@mpt-fo/common/core/services/login-helper.service";

import { ProfileSetupService } from "@mpt-fo/common/core/services/profile-setup/profile-setup.service";
import { UtilityService } from "@mpt-fo/common/core/services/utility.service";
import { IdentityProvider, ModalType, OtpResentMode, ProgressTimelineType, SmileIdImage } from "@mpt-fo/common/kamona/model/kamonal-model";
import { AlertComponent } from "@mpt-fo/common/lean-shared/components/alert/alert.component";
import { ModalOptionsConfig, ModalService } from "@mpt-fo/common/lean-shared/components/nz-modal-service/modal.service";
import { DEFAULT_DIALOG_CLASSES } from "@mpt-fo/common/shared/constants";
import { ActivateDeviceRequestModel } from "@mpt-fo/common/shared/models/device.model";
import { NzModalRef } from "ng-zorro-antd/modal"; 

import { ErrorCode } from "@mpt-fo/common/core/models/onboarding";
import { AppConfig } from "@mpt-fo/common/shared/config/app-config";
import { SettingsService } from "@mpt-fo/common/core/services/settings.service";
import { AlertModalVariants, FaceVerificationSteps } from "./login-liveness-check.model";
import { EncryptionUtil } from "@mpt-fo/common/shared/utils/encryption.util";
import { ScreenManagerService } from "@mpt-fo/common/core/services/screen-manager.service";
import { LocationHelper } from "@mpt-fo/common/core/helpers/location.helper";

@Component({
  selector: "ng-mf-login-liveness-check",
  templateUrl: "./login-liveness-check.component.html",
  styleUrls: ["./login-liveness-check.component.scss"]
})

export class LoginLivenessCheckComponent implements OnInit {

  @ViewChild('faqTemplate', { static: true }) faqTemplate: TemplateRef<any>;

  readonly ModalType = ModalType;
  readonly LIVELINESS_PURPOSE = 'IDENTITY_VERIFICATION';
  readonly OTP_RESEND_PURPOSE = 'USER_VERIFICATION';
  readonly VERIFICATION_FAILED = 'Verification Failed';
  readonly DEFAULT_INTERVAL = 37500;
  readonly MAX_VERIFICATION_PERIOD_IN_MINUTES = 3;
  readonly NO_IMAGE_ERROR = '404018';
  readonly THREE_FAILURES_ERROR = '401036';
  readonly SUSPENDED_ERROR = '401037';
  readonly delayInMilliseconds = 30000;
  readonly TOTAL_TIME_IN_SEC = 4 * 60;
  readonly SECONDS_MEASUREMENT = 60;
  readonly PHONE_NUMBER_LOGIN_TYPE = 'PHONENUMBER';
  readonly FACE_MATCH_CHECK_TYPE = "FACE_MATCH_CHECK";
  readonly ALERT_VARIANTS = AlertModalVariants;
  readonly VERIFICATION_STEPS = FaceVerificationSteps;

  ProgressTimelineType = ProgressTimelineType;
	otpResponse: any;
  runningModal: NzModalRef;
  livenessStep: FaceVerificationSteps = FaceVerificationSteps.INSTRUCTIONS;
  showAlertModal: AlertModalVariants;
  alertErrorMessage: string;
  showPrivacyModal = false;
  showTermsModal = false;
  termsAndConditions: {content: string};
  isLoadingReference = false;
  uploadImageLoader = false;
  isSubmitting = false;
  intervalTime = 1000;
  maxIntervalTime = 32000;
  maximumNoOfRetry = 9;
  cancelled = false;
  countDownTime: {
    hours: string | number;
    minutes: string | number;
    seconds: string | number;
  };
  interval: number;
  countDownInterval: any;
  timeoutId: any;
  counter = 1;
  identityProvider = IdentityProvider.SMILE_ID;
  isOTPFlow = false;
  currentOtpModes = OtpResentMode;
  currentOTPMode: OtpResentMode;
  useResendOtpViaWhatsapp: boolean;
  useResendOtpViaSms: boolean;
  canUseNewUssd: boolean;
  useNewDesignOtpWhatsappUssdDeviceRegistration = false;
  showBothCountDown = false;
  isVerifyingOTP = false;
  isResendingOTP = false;
  confirmingOtp = false;
  isMobile: boolean;
  verificationSuccessCallback: () => void;

  constructor(
    private profileService: ProfileSetupService, 
    private livelinessService: LivelinessService,
    private modalService: ModalService,
    private utilityService: UtilityService,
    private dataLayerService: DataLayerService,
		public user: AuthorizedUser,
		private deviceHelper: DeviceHelperService,
		private loginHelper: LoginHelperService,
		public authService: AuthenticationService,
		private router: Router,
    public config: AppConfig,
    private settingsService : SettingsService,
    private encryptionUtil: EncryptionUtil,
		private screenManager: ScreenManagerService,
    private locationHelper: LocationHelper,
  ){
  }

  ngOnInit() {
    this.otpResponse = this.loginHelper.loginOtpResponse;
    if(!this.otpResponse) {
      this.goBack();
      return;
    }

    if(this.otpResponse.code === ErrorCode.EXTRA_LIVENESS_OTP_CHECK) {
      this.isOTPFlow = true;
    }
    this.isMobile = this.screenManager.isMobile();
    this.setOTPConfig();
    this.initTerms();
  }

  goBack() {
		this.router.navigateByUrl('/login');
	}


  async initTerms() {
    if (!this.termsAndConditions) await this.getTermsAndConditions();
  }

  startLiveliness() {
    this.livenessStep = FaceVerificationSteps.VERIFICATION;
  }

  handleVerificationSuccess() {
    if(this.verificationSuccessCallback) {
      this.verificationSuccessCallback();
    } 
  }

  handleVerificationFailure() {
    this.showAlertModal = undefined;
    this.alertErrorMessage = '';

    if(!this.isOTPFlow) {
      this.goToLogin();
    } 
  }

  setOTPConfig() {
    this.useNewDesignOtpWhatsappUssdDeviceRegistration = this.config.USE_NEW_OTP_DESIGN_DEVICE_REGISTRATION;
    this.useResendOtpViaWhatsapp = this.config.USE_OTP_WHATSAPP_DEVICE_REGISTRATION;
    this.useResendOtpViaSms = this.config.SEND_SMS_OTP_2FA;
    this.canUseNewUssd = false;
    this.showBothCountDown = this.useResendOtpViaWhatsapp && this.useResendOtpViaSms;

    if(this.useResendOtpViaWhatsapp) {
      this.setOTPModeWhatsApp();
    }
  }

  setOTPModeWhatsApp() {
    if(this.useResendOtpViaWhatsapp && !this.useResendOtpViaSms){
      this.currentOTPMode = OtpResentMode.WHATSAPP_MODE;
    }
  }

  async verifyWithOTP(otp: string) {
    this.isVerifyingOTP = true;
		const deviceInformation = this.getDeviceInformation();

    const activateAuthPayload = this.buildActivateAuthParams({...this.otpResponse, otp}, this.otpResponse.reference);

    try {
      const res = await this.authService.activateDeviceOnLoginV2(activateAuthPayload)

      this.isVerifyingOTP = false;
      this.verificationSuccessCallback = () => {
        this.loginHelper.processSessionUser(res, deviceInformation);
      }

      this.showAlertModal = AlertModalVariants.SUCCESS;
    } catch(error) {
      this.isVerifyingOTP = false;
      this.alertErrorMessage = error.error?.responseMessage;
      this.showAlertModal = AlertModalVariants.FAILURE;
    }
	}

  isPhoneNumberLoginType(identityType: string) {
    return identityType === this.PHONE_NUMBER_LOGIN_TYPE;
  }

  buildResendOTPPayload() {
    const {identityType, value} = this.settingsService.getUserTypePayload();

    const usePhoneNumberForResend = 
      this.isPhoneNumberLoginType(identityType);

    const payload = 
      usePhoneNumberForResend ? {mobileNumber: value} : {username: value};

    const notificationChannel = (this.currentOTPMode || OtpResentMode.SMS_MODE)?.split('_')[0];

    return {
      ...payload, 
      authenticationPurpose: this.LIVELINESS_PURPOSE,
      notificationChannel
    }
  }


  handleReloadOTP(mode: OtpResentMode) {
    this.currentOTPMode = mode;

    if(mode === OtpResentMode.USSD_MODE) {
      this.handleResendOTPViaUSSD();
    } else {
      this.handleResendOTP();
    }
  }

  handleResendOTPViaUSSD() {
    this.setConfirmingOtp(true);
  }

  setConfirmingOtp(value: boolean) {
    this.confirmingOtp = value;
  }

  async handleResendOTP() {
    this.isResendingOTP = true;

    try {
      const payload = this.buildResendOTPPayload();
      const res = await this.settingsService.generateOtp2FAPublic(payload, this.OTP_RESEND_PURPOSE);   
      this.otpResponse.message = res?.otpMessage;
      this.otpResponse.ussdCode = res?.ussdCode;
      this.setOTPModeWhatsApp();  
    } catch(error) {
      const msg = StringHelper.getErrorMessageHttpErrorResponse(error);
      
      const data = {
        title: "Something went wrong",
        description: msg || 'Unable to resend OTP.' +
          ' Please try again',
        alertType: 'warning',
        callbackName: 'Close',
      };
      this.alertError(data)

    } finally {
    this.isResendingOTP = false;
    }

  }

  initializeTimers() {
    this.countDownTime = null;
    this.interval = this.DEFAULT_INTERVAL;
    this.clearRunningIntervals();
    this.startCountDown();
  }

  getHashedJobReference() {
    const jobReference = this.encryptionUtil.generateHashedValue(
      this.otpResponse?.reference,
      this.config.S_CODE1,
      this.config.S_CODE2
    );

    return jobReference;
  }

  handleEmitImage(images: SmileIdImage[]) {
    const jobReference = this.getHashedJobReference();

    const payload = {
      images, 
      reference: this.otpResponse.reference,
      jobReference
    };

    this.uploadImageLoader = true;
    this.livelinessService.uploadSmileIdImages(payload).subscribe(() => {
      this.initializeTimers();
      this.onCompletion();
      this.uploadImageLoader = false;
    }, (error) => {
      this.uploadImageLoader = false;
      const msg = StringHelper.getErrorMessageHttpErrorResponse(error);
      const data = {
        title: this.VERIFICATION_FAILED,
        description: msg || `Verification was not completed.  Please try again`,
        alertType: 'warning',
        callbackName: 'Retry Verification',
      };
      this.alertError(data)
    })
  }

  getSmileIdStatus(reference: string, retries) {
    if (this.cancelled) {
      this.isSubmitting = false;
      return;
    }

    const {value: username} = this.settingsService.getUserTypePayload();

    this.isSubmitting = true;
    this.livelinessService
      .validatReferencePublic(reference, this.LIVELINESS_PURPOSE, username)
      .subscribe(
        (res) => {
          this.handleSmileStatusResponse(res, retries);
        }, 
        (error) => {
          this.isSubmitting = false;
          this.runningModal?.destroy();
          clearTimeout(this.timeoutId);

          const errorCode = error.error?.code;
          const err = { description: error?.error?.responseMessage || StringHelper.getErrorMessageHttpErrorResponse(error) };

          this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getEventData({
            errorCode,
            errorMessage: err.description,
          }));

          if (this.isSpecialError(errorCode)) {
            this.showCustomerSupportModal(err.description, errorCode === this.THREE_FAILURES_ERROR, reference);
          } else {
            this.verificationFailed(error);
          }
        }
      );
  }

  handleSmileStatusResponse(res, retries) {
		const deviceInformation = this.getDeviceInformation();

    if (res?.status === 'SUCCESS') {
      this.isSubmitting = false;
      this.dataLayerService.logEventWithData(AuthenticationEvents.success, this.getStatusErrorEventData());
      this.cancel();

      const activateAuthPayload = this.buildActivateAuthParams(res, this.otpResponse.reference);
      this.authService.activateDeviceOnLoginV2(activateAuthPayload)
        .then((res) => {
          this.verificationSuccessCallback = () => {
            this.loginHelper.processSessionUser(res, deviceInformation);
          }
          this.showAlertModal = AlertModalVariants.SUCCESS;
        }).catch((error) => {
            this.isSubmitting = false;
            this.alertErrorMessage = error.error?.responseMessage;
            this.showAlertModal = AlertModalVariants.FAILURE;
        })
    } else if (res?.status === 'FAILED' || (retries >= this.maximumNoOfRetry)) {
      this.alertErrorMessage = "We were unable to verify your identity";
      this.showAlertModal = AlertModalVariants.FAILURE;

      this.dataLayerService.logEventWithData(AuthenticationEvents.failed, this.getStatusErrorEventData({
        errorMessage: 'Liveliness verification failed',
      }));

      this.cancel();
    } else {
      this.incrementCounter(retries + 1);
    }
  }

  verificationFailed(params) {
    const modalParams = {
      title: this.VERIFICATION_FAILED,
      description: params?.error?.responseMessage || `Smile Id verification was not completed.  Please try again`,
      alertType: 'warning',
      callbackName: 'Retry Verification',
    };
    this.runningModal?.destroy();
    this.cancel();

    const restartProcess = params?.error?.responseCode === LivelinessErrorCode.LIVELINESS_REFERENCE_CONSUMED;

    const config = new ModalOptionsConfig();
    config.className = 'moniepoint-dialog';
    config.nzMaskClosable = true;
    config.nzComponentParams.title = modalParams.title;
    config.nzComponentParams.data = 'Retry';
    config.nzComponentParams.alertType = 'confirm';
    config.nzComponentParams.callbackName = restartProcess ? 'Restart' : 'Close';
    config.nzComponentParams.message = modalParams.description;
    config.nzComponentParams.callback = () => {
      this.runningModal?.destroy();
      if(restartProcess) {
        this.router.navigateByUrl('/login');
      }  
    };
    this.runningModal = this.modalService.createModal(AlertComponent, config);
  }

  buildActivateAuthParams(param, reference) {
    const credentials = this.user.loginCredentials;
    const deviceInformation = this.getDeviceInformation();
    const staffUserTokenData = this.loginHelper.staffUserTokenData();

		const params = new ActivateDeviceRequestModel(credentials);
    params.deviceUniqueIdentifier = deviceInformation?.deviceUniqueIdentifier;

    if(this.loginHelper.isNewStaffLogin() && staffUserTokenData && staffUserTokenData.businesses?.length > 0){
			params.businessId = staffUserTokenData.businesses[0].businessId;
			params.refreshToken = staffUserTokenData.tokenData?.refresh_token;
		}
    params.activationToken = param?.response?.identifier;
		params.identifier = param?.response?.identifier;
    params.reference = reference;
    params.otp = param?.otp?.otp;
		return params;
  }

  getDeviceInformation(){
		return this.deviceHelper.getDeviceInformation();
	}

  cancel() {
    clearTimeout(this.timeoutId);
    this.isSubmitting = false;
    this.cancelled = true;
    this.counter = 1;
    this.clearRunningIntervals();
  }

  getStatusErrorEventData(errorDetails?: { errorCode?: string; errorMessage: string; }) {
    return {
      auth_type: this.FACE_MATCH_CHECK_TYPE,
      auth_type_provider: this.identityProvider,
      feature: this.LIVELINESS_PURPOSE,
      ...(errorDetails ? {
        api_error_code: errorDetails.errorCode,
        api_error_message: errorDetails.errorMessage,
        error_message: errorDetails.errorMessage,
      } : {}),
    };
  }

  cancelLiveLiness() {
    clearTimeout(this.timeoutId);
    this.isSubmitting = false;
    this.counter = 1;
    this.livenessStep = FaceVerificationSteps.INSTRUCTIONS;
    this.clearRunningIntervals();
  }

  // timer methods
  getCurrentTime() {
    const second = parseInt(`${this.countDownTime.seconds}`);
    const minute = parseInt(`${this.countDownTime.minutes}`);
    const minutesToSeconds = minute * this.SECONDS_MEASUREMENT;
    return this.TOTAL_TIME_IN_SEC - (second + minutesToSeconds);
  }

  canHideTimerCount() {
    const isZeroMinutes = this.getRefinedTime(this.countDownTime?.minutes) === 0;
    const isFewSeconds = this.getRefinedTime(this.countDownTime?.seconds) <= 10;
    return isZeroMinutes && isFewSeconds;
  }

  getRefinedTime(time) {
    return time > 0 ? time : 0;
  }

  startCountDown() {
    const currentDate = new Date();
    const futureDate = new Date(currentDate.getTime() + this.MAX_VERIFICATION_PERIOD_IN_MINUTES * 60000);
    this.countDownTime = this.utilityService.getTimeFromDate(futureDate.getTime());
    this.countDownInterval = setInterval(() => {
      this.countDownTime = this.utilityService.getTimeFromDate(futureDate.getTime());
    }, 1000);
  }

  initializeTimer() {
    this.countDownTime = null;
    this.interval = this.DEFAULT_INTERVAL;
    this.startCountDown();
  }

  clearRunningIntervals() {
    clearInterval(this.countDownInterval);
    this.countDownTime = null;
  }

  onCompletion() {
    this.isSubmitting = true;
    this.incrementCounter(1);
  }

  incrementCounter(retries) {
    this.counter = this.counter * 2;
    const delayTime = Math.min(this.counter * 1000, this.maxIntervalTime);
    clearTimeout(this.timeoutId);

    this.timeoutId = setTimeout(() => {
      this.getSmileIdStatus(this.otpResponse.reference, retries);
    }, delayTime);
  }


  createTicket(reference) {
    this.livelinessService.postZendeskTicket(reference)
      .subscribe((res) => {
        this.runningModal?.destroy();
        this.modalService.showSuccess('Ticket Created Successfully', res?.data?.message);
      }, (error) => {
        this.runningModal?.destroy();
        const msg = StringHelper.getErrorMessageHttpErrorResponse(error);
        this.modalService.showError('Ticket Creation Failed', msg);
    });
  }

  async getEventData(errorDetails?: { errorCode?: string; errorMessage: string; }) {
    const geoHeaders = await this.locationHelper.getCoordinates();

    return {
      auth_type: this.FACE_MATCH_CHECK_TYPE,
      auth_type_provider: this.identityProvider,
      feature: this.LIVELINESS_PURPOSE,
      ...(geoHeaders ? {
				longitude: geoHeaders.longitude,
				latitude: geoHeaders.latitude,
			} : {}),
      ...(errorDetails ? {
        api_error_code: errorDetails.errorCode,
        api_error_message: errorDetails.errorMessage,
        error_message: errorDetails.errorMessage,
      } : {}),
    };
  }

  // modal methods
  showCustomerSupportModal(message, allowRetry, reference) {
    const config = new ModalOptionsConfig();
    config.className = 'moniepoint-dialog';
    config.nzMaskClosable = false;
    config.nzComponentParams.alertType = 'confirm';
    config.nzComponentParams.callbackName = 'Create Ticket';
    config.nzComponentParams.cancelName = allowRetry ? 'Retry' : 'Cancel';
    config.nzComponentParams.title = this.VERIFICATION_FAILED;
    config.nzComponentParams.message = message;

    if (allowRetry) {
      config.nzComponentParams.messageTemplate = this.faqTemplate;
    }

    config.nzComponentParams.callback = (result) => {
      this.cancel();
      if (result) {
        this.createTicket(reference);
        this.goToLogin();
        return;
      }
      this.runningModal?.destroy();
      this.goToLogin();
    };

    config.nzComponentParams.cancelCallback = () => {
      this.goToLogin();
    }
    this.runningModal = this.modalService.createModal(AlertComponent, config);
  }

  closeAlertStateModal() {
    this.showAlertModal = undefined;
  }

  alertError(data) {
    const config = new ModalOptionsConfig();
    config.className = DEFAULT_DIALOG_CLASSES;

    config.nzComponentParams.alertType = 'error';
    config.nzComponentParams.title = data?.title ?? 'Unable to complete request';
    config.nzComponentParams.message = data?.description;
    config.nzComponentParams.callbackName = data?.callbackName ?? 'Try again';

    config.nzComponentParams.callback = () => {
      if(data?.callback) {
        data.callback();
      }
      this.runningModal.destroy();
    }

    this.runningModal = this.modalService.alert(config);
  }


  isSpecialError(code) {
    return code === this.NO_IMAGE_ERROR || code === this.THREE_FAILURES_ERROR || code === this.SUSPENDED_ERROR;
  }

  openPrivacy() {
    this.showPrivacyModal = true;
  }

  handleCloseModal() {
    this.showAlertModal = undefined;
  }

  handleClosePrivacyModal(){
    this.showPrivacyModal = false;
  }

  openTermsAndConditions() {
    this.showTermsModal = true;

  }

  handleCloseTermsModal(){
    this.showTermsModal = false;
  }

  goToLogin() {
    this.profileService.routeToLogin();
  }

  async getTermsAndConditions() {
    this.termsAndConditions = await this.profileService.
      termsAndConditions();
  }

}